class SoundKit {
  constructor() {
    this.ctx = null;
    this.master = null;
  }

  unlock() {
    if (!this.ctx) {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      this.ctx = new Ctx();
      this.master = this.ctx.createGain();
      this.master.gain.value = 0.5;
      this.master.connect(this.ctx.destination);
    }
    if (this.ctx.state === "suspended") this.ctx.resume();
  }

  tone({ freq0, freq1 = freq0, dur, type = "sine", gain = 0.15, delay = 0 }) {
    if (!this.ctx || !this.master) return;
    const t0 = this.ctx.currentTime + delay;
    const osc = this.ctx.createOscillator();
    const env = this.ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq0, t0);
    osc.frequency.exponentialRampToValueAtTime(Math.max(freq1, 1), t0 + dur);
    env.gain.setValueAtTime(gain, t0);
    env.gain.exponentialRampToValueAtTime(0.0008, t0 + dur);
    osc.connect(env);
    env.connect(this.master);
    osc.start(t0);
    osc.stop(t0 + dur + 0.02);
  }

  shot() {
    this.tone({ freq0: 190, freq1: 85, dur: 0.09, type: "square", gain: 0.1 });
    this.tone({ freq0: 950, freq1: 420, dur: 0.05, type: "triangle", gain: 0.06 });
  }

  emptyClick() {
    this.tone({ freq0: 130, freq1: 70, dur: 0.07, type: "square", gain: 0.07 });
  }

  reload() {
    this.tone({ freq0: 260, freq1: 200, dur: 0.08, type: "square", gain: 0.07 });
    this.tone({ freq0: 330, freq1: 260, dur: 0.08, type: "square", gain: 0.07, delay: 0.14 });
  }

  botImpact() {
    this.tone({ freq0: 520, freq1: 700, dur: 0.12, type: "triangle", gain: 0.12 });
  }

  botBlooms() {
    [392, 523.25, 659.25].forEach((f, i) =>
      this.tone({ freq0: f, dur: 0.5, type: "sine", gain: 0.09, delay: i * 0.07 })
    );
  }

  playerBlooms() {
    this.tone({ freq0: 220, freq1: 55, dur: 0.5, type: "sawtooth", gain: 0.12 });
    [523.25, 415.3].forEach((f, i) =>
      this.tone({ freq0: f, dur: 0.7, type: "sine", gain: 0.08, delay: 0.1 + i * 0.05 })
    );
  }

  hurt() {
    this.tone({ freq0: 140, freq1: 70, dur: 0.18, type: "sawtooth", gain: 0.1 });
  }

  dispose() {
    if (this.ctx) {
      this.ctx.close();
      this.ctx = null;
      this.master = null;
    }
  }
}

export { SoundKit };
export default SoundKit;
